import { openDB } from 'idb';

const createDatabase = async () => {
  const db = await openDB('FUTURISS', 3, {
    upgrade(db, oldVersion, newVersion, transaction) {
      
      if (!db.objectStoreNames.contains('universities')) {
        db.createObjectStore('universities', { keyPath: 'id', autoIncrement: true });
      }

      if (!db.objectStoreNames.contains('currentyears')) {
        const currentyearsStore = db.createObjectStore('currentyears', { keyPath: 'id', autoIncrement: true });
        currentyearsStore.createIndex('universityIDICurrentYearndex', 'universityID');
      }

      if (!db.objectStoreNames.contains('faculties')) {
        const facultiesStore = db.createObjectStore('faculties', { keyPath: 'id', autoIncrement: true });
        facultiesStore.createIndex('universityIDIndex', 'universityID');
      }

      if (!db.objectStoreNames.contains('departments')) {
        const departmentsStore = db.createObjectStore('departments', { keyPath: 'id', autoIncrement: true });
        departmentsStore.createIndex('combinedIDIndex', ['universityID', 'facultyID']); // Compound index
      }
    },
  });

  return db;
};

// Insert or update all departments data in IndexedDB
const insertDepartmentToDB = async (departments) => {
  const db = await createDatabase();

  const tx = db.transaction('departments', 'readwrite');
  const store = tx.objectStore('departments');

  try {
    for (const department of departments) {
      await store.put(department);
    }
    await tx.done;
  } catch (error) {
    console.error('Error inserting or updating departments:', error);
    throw error;
  }
};

// Retrieve all departments filtered by universityID and facultyID
const getDepartmentsFromDB = async (universityID, facultyID) => {
 //  console.log("universityID ### ", universityID);
 //  console.log("facultyID ### ", facultyID);

  if (Number(universityID) > 0 && Number(facultyID) > 0) {
    const db = await createDatabase();
    const tx = db.transaction('departments', 'readonly');
    const store = tx.objectStore('departments');
    const combinedIDIndex = store.index('combinedIDIndex');

    const range = IDBKeyRange.only([universityID, facultyID]); // Compound key query
    const departments = [];

    try {
      let cursor = await combinedIDIndex.openCursor(range);

      while (cursor) {
        departments.push(cursor.value);
        cursor = await cursor.continue();
      }

      await tx.done;

      // Sort by 'department' name property, if it exists
      departments.sort((a, b) => {
        if (a.department && b.department) {
          return a.department.localeCompare(b.department);
        }
        return 0; // Keep the order for items without 'department'
      });

      return departments;
    } catch (error) {
      console.error("An error occurred while retrieving departments:", error);
      throw error;
    }
  }
};

const countDepartmentsFromDB = async () => {
  const db = await createDatabase();
  const tx = db.transaction('departments', 'readonly');
  const store = tx.objectStore('departments');

  try {
    const count = await store.count();
    await tx.done;
    return count;
  } catch (error) {
    console.error('Error counting departments:', error);
    throw error;
  }
};

const fetchDepartmentsAndCount = async (departments, universityID, facultyID) => {
  try {
    await insertDepartmentToDB(departments);

    const [filteredDepartments, count] = await Promise.all([
      getDepartmentsFromDB(universityID, facultyID),
      countDepartmentsFromDB()
    ]);

    return { departments: filteredDepartments, count };
  } catch (error) {
    console.error('Error fetching departments and count:', error);
    throw error;
  }
};

export { insertDepartmentToDB, getDepartmentsFromDB, countDepartmentsFromDB, fetchDepartmentsAndCount };